const actions = {
  CREATE_MDN_SWAP_REQUEST: "CREATE_MDN_SWAP_REQUEST",
  CREATE_MDN_SWAP_REQUEST_SUCCESSFUL: "CREATE_MDN_SWAP_REQUEST_SUCCESSFUL",
  CREATE_MDN_SWAP_REQUEST_FAILED: "CREATE_MDN_SWAP_REQUEST_FAILED",

  GET_MDN_SWAP_REQUEST: "GET_MDN_SWAP_REQUEST",
  GET_MDN_SWAP_REQUEST_SUCCESSFUL: "GET_MDN_SWAP_REQUEST_SUCCESSFUL",
  GET_MDN_SWAP_REQUEST_FAILED: "GET_MDN_SWAP_REQUEST_FAILED",

  GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST:
    "GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST",
  GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL:
    "GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL",
  GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_FAILED:
    "GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_FAILED",

  RESET_MDN_SWAP_MESSAGE: "RESET_MDN_SWAP_MESSAGE",

  createMdnSwapRequest: (data) => ({
    type: actions.CREATE_MDN_SWAP_REQUEST,
    payload: { data },
  }),
  createMdnSwapRequestSuccessful: (message) => ({
    type: actions.CREATE_MDN_SWAP_REQUEST_SUCCESSFUL,
    message,
  }),
  createMdnSwapRequestFailed: (error) => ({
    type: actions.CREATE_MDN_SWAP_REQUEST_FAILED,
    error,
  }),

  getMdnSwapRequest: (data) => ({
    type: actions.GET_MDN_SWAP_REQUEST,
    payload: { data },
  }),
  getMdnSwapRequestSuccessful: (data) => ({
    type: actions.GET_MDN_SWAP_REQUEST_SUCCESSFUL,
    payload: { data },
  }),
  getMdnSwapRequestFailed: (error) => ({
    type: actions.GET_MDN_SWAP_REQUEST_FAILED,
    error,
  }),

  getMdnSwapBatchTransactionIdRequest: (data) => ({
    type: actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST,
    payload: { data },
  }),
  getMdnSwapBatchTransactionIdRequestSuccessful: (result) => ({
    type: actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL,
    payload: { result },
  }),
  getMdnSwapBatchTransactionIdRequestFailed: (error) => ({
    type: actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_FAILED,
    error,
  }),

  resetMdnSwapMessage: () => ({
    type: actions.RESET_MDN_SWAP_MESSAGE,
  }),
};
export default actions;
